import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavegacaoCarregandoComponent } from './shared/carregando/navegacao-carregando.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [RouterOutlet, NavegacaoCarregandoComponent],
})
export class AppComponent {}
